import { createIcon } from "@chakra-ui/react";

export const Triangle = createIcon({
  displayName: "Triangle",
  viewBox: "0 0 72 72",
  path: [
    <mask
      id="2zznvefesa"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="73"
      height="72"
    >
      <path fill="#D9D9D9" d="M.864 0h72v72h-72z" />
    </mask>,
    <g mask="url(#2zznvefesa)">
      <path
        d="M.977 55.191 2.72 51.21l1.594-4.073 1.841-3.957 2.421-3.682 1.632-4.056 2.274-3.752 1.454-4.14 2.472-3.657 1.525-4.107 1.855-3.95 1.801-3.977 1.772-4.198 3.805 2.556 4.26 1.165 3.94 1.84 3.947 1.822 3.834 2.06 3.92 1.88 3.672 2.404 4.177 1.34 3.971 1.773 3.7 2.344 3.854 2.02 3.599 1.351-3.394 1.891-4.28.95-4.059 1.576-4.07 1.543-4.15 1.314-3.896 2.035-4.106 1.44-4.446.483-3.814 2.264-4.188 1.211-4.22 1.12-4.152 1.31-4.014 1.7-4.182 1.229-3.812 2.272L5.07 53.77.977 55.19z"
        fill="currentColor"
      />
    </g>,
  ],
  defaultProps: {
    color: "#B6DE83",
  },
});

export default Triangle;
